module.exports = __webpack_public_path__ + "img/xdcj2.fdbec8a6.png";